import Vue from 'vue'
import Main from './Main.vue'
import router from './router'
import store from './store'
import VueSwing from 'vue-swing'

Vue.config.productionTip = false

Vue.component('vue-swing', VueSwing)

new Vue({
  router,
  store,
  render: function (h) { return h(Main) }
}).$mount('#app')
